import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  CreateMyPasswordContent,
  InputValueEvent
} from './model/create-my-password';

@Component({
  selector: 'idp-create-my-password',
  templateUrl: './create-my-password.component.html',
  styleUrls: ['./create-my-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateMyPasswordComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() content = {} as CreateMyPasswordContent;
  @Input() callBackFunction!: () => void;
  @Output() formSubmitEvent = new EventEmitter<boolean>();
  @Output() focusInvalidField = new EventEmitter<string>();
  @Output() fieldFocusOut = new EventEmitter<string>();
  @Output() inputChange = new EventEmitter<string>();
  @Output() closeOverlayMessage = new EventEmitter<boolean>();
  @Output() updatePasswordHint = new EventEmitter<string>();
  @Output() togglePassword = new EventEmitter<boolean>();
  formGroup!: UntypedFormGroup;

  ngOnInit() {
    this.formGroup = this.content.formGroup as UntypedFormGroup;
  }

  newPasswordformControl(): UntypedFormControl {
    return this.formGroup?.get('newPassword') as UntypedFormControl;
  }

  confirmPasswordformControl(): UntypedFormControl {
    return this.formGroup?.get('confirmPassword') as UntypedFormControl;
  }

  get showErrorMessageNewPassword() {
    const control = this.newPasswordformControl();
    return (
      control &&
      this.content.formAttributes.newPasswordControlTouched &&
      control.invalid
    );
  }

  get showErrorMessageConfirmPassword() {
    const control = this.confirmPasswordformControl();
    return (
      control &&
      this.content.formAttributes?.confirmPasswordControlTouched &&
      control.invalid
    );
  }

  get showErrorMessagePasswordMismatch() {
    const control = this.confirmPasswordformControl();
    return (
      (control?.dirty ||
        this.content.formAttributes?.confirmPasswordControlTouched) &&
      control.errors?.['INVALID_CR_PASSWORD']
    );
  }

  get showOnPasswordsMatch() {
    const control = this.confirmPasswordformControl();
    return (
      (control?.dirty ||
        this.content.formAttributes?.confirmPasswordControlTouched) &&
      control.valid
    );
  }

  onChange(): void {
    this.inputChange.emit();
  }

  onFocussedOut(fieldName: string): void {
    this.fieldFocusOut.emit(fieldName);
  }

  onFocusFirstInvalidField(): void {
    this.focusInvalidField.emit();
  }

  submit(): void {
    this.formSubmitEvent.emit(true);
  }

  updatePasswordHintStatus(event?: KeyboardEvent | InputValueEvent): void {
    const value = this.extractPasswordValue(event);
    this.updatePasswordHint.emit(value);
  }

  private extractPasswordValue(
    event?: KeyboardEvent | InputValueEvent
  ): string {
    if (!event) {
      return this.getFormPasswordValue();
    }
    return this.getEventValue(event);
  }

  private getEventValue(event: KeyboardEvent | InputValueEvent): string {
    if ('target' in event) {
      return ((event as KeyboardEvent).target as HTMLInputElement).value;
    }
    return (event as InputValueEvent).value;
  }

  private getFormPasswordValue(): string {
    return this.formGroup.get('newPassword')?.value?.value || '';
  }

  closePopup() {
    this.closeOverlayMessage.emit(false);
  }

  onEyeIconClick() {
    this.togglePassword.emit();
  }

  ngAfterViewInit(): void {
    this.onChange();
  }

  ngOnDestroy(): void {
    this.callBackFunction();
  }
}
